export default __webpack_public_path__ + "static/media/web_gmm_750amazon_cancermama_330x330.54e65f38.webp";